// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_communication.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelView
 */
export interface SlackChannelView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: bool active = 4
     */
    active: boolean;
    /**
     * @generated from protobuf field: string binding_id = 5
     */
    bindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MSTeamsChannelView
 */
export interface MSTeamsChannelView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string channel_name = 2
     */
    channelName: string;
    /**
     * @generated from protobuf field: bool active = 3
     */
    active: boolean;
    /**
     * @generated from protobuf field: string team_id = 4
     */
    teamId: string;
    /**
     * @generated from protobuf field: string external_directory_id = 5
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string binding_id = 6
     */
    bindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelRequest
 */
export interface AccessReviewCommunicationServiceGetChannelRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelResponse
 */
export interface AccessReviewCommunicationServiceGetChannelResponse {
    /**
     * @generated from protobuf oneof: channel_metadata
     */
    channelMetadata: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelView slack_channel = 100
         */
        slackChannel: SlackChannelView;
    } | {
        oneofKind: "msTeamsChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel = 101
         */
        msTeamsChannel: MSTeamsChannelView;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsRequest
 */
export interface AccessReviewCommunicationServiceListChannelsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsResponse
 */
export interface AccessReviewCommunicationServiceListChannelsResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelView slack_channel = 1
     */
    slackChannel?: SlackChannelView;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel = 2
     */
    msTeamsChannel?: MSTeamsChannelView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannel
 */
export interface SlackChannel {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MSTeamsChannel
 */
export interface MSTeamsChannel {
    /**
     * @generated from protobuf field: string channel_name = 1
     */
    channelName: string;
    /**
     * @generated from protobuf field: string external_directory_id = 2
     */
    externalDirectoryId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateRequest
 */
export interface AccessReviewCommunicationServiceCreateRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf oneof: channel_metadata
     */
    channelMetadata: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannel slack_channel = 100
         */
        slackChannel: SlackChannel;
    } | {
        oneofKind: "msTeamsChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.MSTeamsChannel ms_teams_channel = 101
         */
        msTeamsChannel: MSTeamsChannel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateResponse
 */
export interface AccessReviewCommunicationServiceCreateResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateRequest
 */
export interface AccessReviewCommunicationServiceActivateRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string channel_binding_id = 2
     */
    channelBindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateResponse
 */
export interface AccessReviewCommunicationServiceActivateResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateRequest
 */
export interface AccessReviewCommunicationServiceDeactivateRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string channel_binding_id = 2
     */
    channelBindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateResponse
 */
export interface AccessReviewCommunicationServiceDeactivateResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameRequest
 */
export interface AccessReviewCommunicationServiceValidateChannelNameRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf oneof: channel_metadata
     */
    channelMetadata: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannel slack_channel = 100
         */
        slackChannel: SlackChannel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelValid
 */
export interface SlackChannelValid {
    /**
     * @generated from protobuf field: bool is_slack_validation_reason = 1
     */
    isSlackValidationReason: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelNotUnique
 */
export interface SlackChannelNotUnique {
    /**
     * @generated from protobuf field: bool is_slack_validation_reason = 1
     */
    isSlackValidationReason: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelNameInvalid
 */
export interface SlackChannelNameInvalid {
    /**
     * @generated from protobuf field: bool is_slack_validation_reason = 1
     */
    isSlackValidationReason: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameResponse
 */
export interface AccessReviewCommunicationServiceValidateChannelNameResponse {
    /**
     * @generated from protobuf oneof: validation_response
     */
    validationResponse: {
        oneofKind: "slackChannelValid";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelValid slack_channel_valid = 100
         */
        slackChannelValid: SlackChannelValid;
    } | {
        oneofKind: "slackChannelNotUnique";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelNotUnique slack_channel_not_unique = 101
         */
        slackChannelNotUnique: SlackChannelNotUnique;
    } | {
        oneofKind: "slackChannelNameInvalid";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelNameInvalid slack_channel_name_invalid = 102
         */
        slackChannelNameInvalid: SlackChannelNameInvalid;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteRequest
 */
export interface AccessReviewCommunicationServiceDeleteRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * An AR can notify on multiple channels, specify via the ID which channel to delete
     *
     * @generated from protobuf field: string channel_binding_id = 2
     */
    channelBindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteResponse
 */
export interface AccessReviewCommunicationServiceDeleteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelView$Type extends MessageType<SlackChannelView> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SlackChannelView>): SlackChannelView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.description = "";
        message.active = false;
        message.bindingId = "";
        if (value !== undefined)
            reflectionMergePartial<SlackChannelView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SlackChannelView): SlackChannelView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool active */ 4:
                    message.active = reader.bool();
                    break;
                case /* string binding_id */ 5:
                    message.bindingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SlackChannelView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool active = 4; */
        if (message.active !== false)
            writer.tag(4, WireType.Varint).bool(message.active);
        /* string binding_id = 5; */
        if (message.bindingId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.bindingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelView
 */
export const SlackChannelView = new SlackChannelView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsChannelView$Type extends MessageType<MSTeamsChannelView> {
    constructor() {
        super("c1.api.accessreview.v1.MSTeamsChannelView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "channel_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "team_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<MSTeamsChannelView>): MSTeamsChannelView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.channelName = "";
        message.active = false;
        message.teamId = "";
        message.externalDirectoryId = "";
        message.bindingId = "";
        if (value !== undefined)
            reflectionMergePartial<MSTeamsChannelView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MSTeamsChannelView): MSTeamsChannelView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string channel_name */ 2:
                    message.channelName = reader.string();
                    break;
                case /* bool active */ 3:
                    message.active = reader.bool();
                    break;
                case /* string team_id */ 4:
                    message.teamId = reader.string();
                    break;
                case /* string external_directory_id */ 5:
                    message.externalDirectoryId = reader.string();
                    break;
                case /* string binding_id */ 6:
                    message.bindingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MSTeamsChannelView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string channel_name = 2; */
        if (message.channelName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelName);
        /* bool active = 3; */
        if (message.active !== false)
            writer.tag(3, WireType.Varint).bool(message.active);
        /* string team_id = 4; */
        if (message.teamId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.teamId);
        /* string external_directory_id = 5; */
        if (message.externalDirectoryId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalDirectoryId);
        /* string binding_id = 6; */
        if (message.bindingId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.bindingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MSTeamsChannelView
 */
export const MSTeamsChannelView = new MSTeamsChannelView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceGetChannelRequest$Type extends MessageType<AccessReviewCommunicationServiceGetChannelRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceGetChannelRequest>): AccessReviewCommunicationServiceGetChannelRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceGetChannelRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceGetChannelRequest): AccessReviewCommunicationServiceGetChannelRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceGetChannelRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelRequest
 */
export const AccessReviewCommunicationServiceGetChannelRequest = new AccessReviewCommunicationServiceGetChannelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceGetChannelResponse$Type extends MessageType<AccessReviewCommunicationServiceGetChannelResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelResponse", [
            { no: 100, name: "slack_channel", kind: "message", oneof: "channelMetadata", T: () => SlackChannelView },
            { no: 101, name: "ms_teams_channel", kind: "message", oneof: "channelMetadata", T: () => MSTeamsChannelView }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceGetChannelResponse>): AccessReviewCommunicationServiceGetChannelResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.channelMetadata = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceGetChannelResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceGetChannelResponse): AccessReviewCommunicationServiceGetChannelResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.SlackChannelView slack_channel */ 100:
                    message.channelMetadata = {
                        oneofKind: "slackChannel",
                        slackChannel: SlackChannelView.internalBinaryRead(reader, reader.uint32(), options, (message.channelMetadata as any).slackChannel)
                    };
                    break;
                case /* c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel */ 101:
                    message.channelMetadata = {
                        oneofKind: "msTeamsChannel",
                        msTeamsChannel: MSTeamsChannelView.internalBinaryRead(reader, reader.uint32(), options, (message.channelMetadata as any).msTeamsChannel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceGetChannelResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.SlackChannelView slack_channel = 100; */
        if (message.channelMetadata.oneofKind === "slackChannel")
            SlackChannelView.internalBinaryWrite(message.channelMetadata.slackChannel, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel = 101; */
        if (message.channelMetadata.oneofKind === "msTeamsChannel")
            MSTeamsChannelView.internalBinaryWrite(message.channelMetadata.msTeamsChannel, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelResponse
 */
export const AccessReviewCommunicationServiceGetChannelResponse = new AccessReviewCommunicationServiceGetChannelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceListChannelsRequest$Type extends MessageType<AccessReviewCommunicationServiceListChannelsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceListChannelsRequest>): AccessReviewCommunicationServiceListChannelsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceListChannelsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceListChannelsRequest): AccessReviewCommunicationServiceListChannelsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceListChannelsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsRequest
 */
export const AccessReviewCommunicationServiceListChannelsRequest = new AccessReviewCommunicationServiceListChannelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceListChannelsResponse$Type extends MessageType<AccessReviewCommunicationServiceListChannelsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsResponse", [
            { no: 1, name: "slack_channel", kind: "message", T: () => SlackChannelView },
            { no: 2, name: "ms_teams_channel", kind: "message", T: () => MSTeamsChannelView }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceListChannelsResponse>): AccessReviewCommunicationServiceListChannelsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceListChannelsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceListChannelsResponse): AccessReviewCommunicationServiceListChannelsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.SlackChannelView slack_channel */ 1:
                    message.slackChannel = SlackChannelView.internalBinaryRead(reader, reader.uint32(), options, message.slackChannel);
                    break;
                case /* c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel */ 2:
                    message.msTeamsChannel = MSTeamsChannelView.internalBinaryRead(reader, reader.uint32(), options, message.msTeamsChannel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceListChannelsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.SlackChannelView slack_channel = 1; */
        if (message.slackChannel)
            SlackChannelView.internalBinaryWrite(message.slackChannel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel = 2; */
        if (message.msTeamsChannel)
            MSTeamsChannelView.internalBinaryWrite(message.msTeamsChannel, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsResponse
 */
export const AccessReviewCommunicationServiceListChannelsResponse = new AccessReviewCommunicationServiceListChannelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannel$Type extends MessageType<SlackChannel> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannel", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "80", pattern: "^[a-z0-9._-]+$" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "250" } } } }
        ]);
    }
    create(value?: PartialMessage<SlackChannel>): SlackChannel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<SlackChannel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SlackChannel): SlackChannel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SlackChannel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannel
 */
export const SlackChannel = new SlackChannel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsChannel$Type extends MessageType<MSTeamsChannel> {
    constructor() {
        super("c1.api.accessreview.v1.MSTeamsChannel", [
            { no: 1, name: "channel_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "50", pattern: "^[a-zA-Z0-9]([a-zA-Z0-9 _.-]*[a-zA-Z0-9 _-])?$" } } } },
            { no: 2, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<MSTeamsChannel>): MSTeamsChannel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.channelName = "";
        message.externalDirectoryId = "";
        if (value !== undefined)
            reflectionMergePartial<MSTeamsChannel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MSTeamsChannel): MSTeamsChannel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string channel_name */ 1:
                    message.channelName = reader.string();
                    break;
                case /* string external_directory_id */ 2:
                    message.externalDirectoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MSTeamsChannel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string channel_name = 1; */
        if (message.channelName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.channelName);
        /* string external_directory_id = 2; */
        if (message.externalDirectoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalDirectoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MSTeamsChannel
 */
export const MSTeamsChannel = new MSTeamsChannel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceCreateRequest$Type extends MessageType<AccessReviewCommunicationServiceCreateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 100, name: "slack_channel", kind: "message", oneof: "channelMetadata", T: () => SlackChannel },
            { no: 101, name: "ms_teams_channel", kind: "message", oneof: "channelMetadata", T: () => MSTeamsChannel }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceCreateRequest>): AccessReviewCommunicationServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.channelMetadata = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceCreateRequest): AccessReviewCommunicationServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.SlackChannel slack_channel */ 100:
                    message.channelMetadata = {
                        oneofKind: "slackChannel",
                        slackChannel: SlackChannel.internalBinaryRead(reader, reader.uint32(), options, (message.channelMetadata as any).slackChannel)
                    };
                    break;
                case /* c1.api.accessreview.v1.MSTeamsChannel ms_teams_channel */ 101:
                    message.channelMetadata = {
                        oneofKind: "msTeamsChannel",
                        msTeamsChannel: MSTeamsChannel.internalBinaryRead(reader, reader.uint32(), options, (message.channelMetadata as any).msTeamsChannel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.SlackChannel slack_channel = 100; */
        if (message.channelMetadata.oneofKind === "slackChannel")
            SlackChannel.internalBinaryWrite(message.channelMetadata.slackChannel, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.MSTeamsChannel ms_teams_channel = 101; */
        if (message.channelMetadata.oneofKind === "msTeamsChannel")
            MSTeamsChannel.internalBinaryWrite(message.channelMetadata.msTeamsChannel, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateRequest
 */
export const AccessReviewCommunicationServiceCreateRequest = new AccessReviewCommunicationServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceCreateResponse$Type extends MessageType<AccessReviewCommunicationServiceCreateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateResponse", []);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceCreateResponse>): AccessReviewCommunicationServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceCreateResponse): AccessReviewCommunicationServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateResponse
 */
export const AccessReviewCommunicationServiceCreateResponse = new AccessReviewCommunicationServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceActivateRequest$Type extends MessageType<AccessReviewCommunicationServiceActivateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "channel_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceActivateRequest>): AccessReviewCommunicationServiceActivateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.channelBindingId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceActivateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceActivateRequest): AccessReviewCommunicationServiceActivateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string channel_binding_id */ 2:
                    message.channelBindingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceActivateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string channel_binding_id = 2; */
        if (message.channelBindingId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelBindingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateRequest
 */
export const AccessReviewCommunicationServiceActivateRequest = new AccessReviewCommunicationServiceActivateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceActivateResponse$Type extends MessageType<AccessReviewCommunicationServiceActivateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateResponse", []);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceActivateResponse>): AccessReviewCommunicationServiceActivateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceActivateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceActivateResponse): AccessReviewCommunicationServiceActivateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceActivateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateResponse
 */
export const AccessReviewCommunicationServiceActivateResponse = new AccessReviewCommunicationServiceActivateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeactivateRequest$Type extends MessageType<AccessReviewCommunicationServiceDeactivateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "channel_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceDeactivateRequest>): AccessReviewCommunicationServiceDeactivateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.channelBindingId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceDeactivateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceDeactivateRequest): AccessReviewCommunicationServiceDeactivateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string channel_binding_id */ 2:
                    message.channelBindingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceDeactivateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string channel_binding_id = 2; */
        if (message.channelBindingId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelBindingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateRequest
 */
export const AccessReviewCommunicationServiceDeactivateRequest = new AccessReviewCommunicationServiceDeactivateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeactivateResponse$Type extends MessageType<AccessReviewCommunicationServiceDeactivateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateResponse", []);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceDeactivateResponse>): AccessReviewCommunicationServiceDeactivateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceDeactivateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceDeactivateResponse): AccessReviewCommunicationServiceDeactivateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceDeactivateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateResponse
 */
export const AccessReviewCommunicationServiceDeactivateResponse = new AccessReviewCommunicationServiceDeactivateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceValidateChannelNameRequest$Type extends MessageType<AccessReviewCommunicationServiceValidateChannelNameRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 100, name: "slack_channel", kind: "message", oneof: "channelMetadata", T: () => SlackChannel }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceValidateChannelNameRequest>): AccessReviewCommunicationServiceValidateChannelNameRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.channelMetadata = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceValidateChannelNameRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceValidateChannelNameRequest): AccessReviewCommunicationServiceValidateChannelNameRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.SlackChannel slack_channel */ 100:
                    message.channelMetadata = {
                        oneofKind: "slackChannel",
                        slackChannel: SlackChannel.internalBinaryRead(reader, reader.uint32(), options, (message.channelMetadata as any).slackChannel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceValidateChannelNameRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.SlackChannel slack_channel = 100; */
        if (message.channelMetadata.oneofKind === "slackChannel")
            SlackChannel.internalBinaryWrite(message.channelMetadata.slackChannel, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameRequest
 */
export const AccessReviewCommunicationServiceValidateChannelNameRequest = new AccessReviewCommunicationServiceValidateChannelNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelValid$Type extends MessageType<SlackChannelValid> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelValid", [
            { no: 1, name: "is_slack_validation_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SlackChannelValid>): SlackChannelValid {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSlackValidationReason = false;
        if (value !== undefined)
            reflectionMergePartial<SlackChannelValid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SlackChannelValid): SlackChannelValid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_slack_validation_reason */ 1:
                    message.isSlackValidationReason = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SlackChannelValid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_slack_validation_reason = 1; */
        if (message.isSlackValidationReason !== false)
            writer.tag(1, WireType.Varint).bool(message.isSlackValidationReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelValid
 */
export const SlackChannelValid = new SlackChannelValid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelNotUnique$Type extends MessageType<SlackChannelNotUnique> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelNotUnique", [
            { no: 1, name: "is_slack_validation_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SlackChannelNotUnique>): SlackChannelNotUnique {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSlackValidationReason = false;
        if (value !== undefined)
            reflectionMergePartial<SlackChannelNotUnique>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SlackChannelNotUnique): SlackChannelNotUnique {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_slack_validation_reason */ 1:
                    message.isSlackValidationReason = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SlackChannelNotUnique, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_slack_validation_reason = 1; */
        if (message.isSlackValidationReason !== false)
            writer.tag(1, WireType.Varint).bool(message.isSlackValidationReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelNotUnique
 */
export const SlackChannelNotUnique = new SlackChannelNotUnique$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelNameInvalid$Type extends MessageType<SlackChannelNameInvalid> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelNameInvalid", [
            { no: 1, name: "is_slack_validation_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SlackChannelNameInvalid>): SlackChannelNameInvalid {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSlackValidationReason = false;
        if (value !== undefined)
            reflectionMergePartial<SlackChannelNameInvalid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SlackChannelNameInvalid): SlackChannelNameInvalid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_slack_validation_reason */ 1:
                    message.isSlackValidationReason = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SlackChannelNameInvalid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_slack_validation_reason = 1; */
        if (message.isSlackValidationReason !== false)
            writer.tag(1, WireType.Varint).bool(message.isSlackValidationReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelNameInvalid
 */
export const SlackChannelNameInvalid = new SlackChannelNameInvalid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceValidateChannelNameResponse$Type extends MessageType<AccessReviewCommunicationServiceValidateChannelNameResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameResponse", [
            { no: 100, name: "slack_channel_valid", kind: "message", oneof: "validationResponse", T: () => SlackChannelValid },
            { no: 101, name: "slack_channel_not_unique", kind: "message", oneof: "validationResponse", T: () => SlackChannelNotUnique },
            { no: 102, name: "slack_channel_name_invalid", kind: "message", oneof: "validationResponse", T: () => SlackChannelNameInvalid }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceValidateChannelNameResponse>): AccessReviewCommunicationServiceValidateChannelNameResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.validationResponse = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceValidateChannelNameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceValidateChannelNameResponse): AccessReviewCommunicationServiceValidateChannelNameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.SlackChannelValid slack_channel_valid */ 100:
                    message.validationResponse = {
                        oneofKind: "slackChannelValid",
                        slackChannelValid: SlackChannelValid.internalBinaryRead(reader, reader.uint32(), options, (message.validationResponse as any).slackChannelValid)
                    };
                    break;
                case /* c1.api.accessreview.v1.SlackChannelNotUnique slack_channel_not_unique */ 101:
                    message.validationResponse = {
                        oneofKind: "slackChannelNotUnique",
                        slackChannelNotUnique: SlackChannelNotUnique.internalBinaryRead(reader, reader.uint32(), options, (message.validationResponse as any).slackChannelNotUnique)
                    };
                    break;
                case /* c1.api.accessreview.v1.SlackChannelNameInvalid slack_channel_name_invalid */ 102:
                    message.validationResponse = {
                        oneofKind: "slackChannelNameInvalid",
                        slackChannelNameInvalid: SlackChannelNameInvalid.internalBinaryRead(reader, reader.uint32(), options, (message.validationResponse as any).slackChannelNameInvalid)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceValidateChannelNameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.SlackChannelValid slack_channel_valid = 100; */
        if (message.validationResponse.oneofKind === "slackChannelValid")
            SlackChannelValid.internalBinaryWrite(message.validationResponse.slackChannelValid, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SlackChannelNotUnique slack_channel_not_unique = 101; */
        if (message.validationResponse.oneofKind === "slackChannelNotUnique")
            SlackChannelNotUnique.internalBinaryWrite(message.validationResponse.slackChannelNotUnique, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SlackChannelNameInvalid slack_channel_name_invalid = 102; */
        if (message.validationResponse.oneofKind === "slackChannelNameInvalid")
            SlackChannelNameInvalid.internalBinaryWrite(message.validationResponse.slackChannelNameInvalid, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameResponse
 */
export const AccessReviewCommunicationServiceValidateChannelNameResponse = new AccessReviewCommunicationServiceValidateChannelNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeleteRequest$Type extends MessageType<AccessReviewCommunicationServiceDeleteRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "channel_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceDeleteRequest>): AccessReviewCommunicationServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.channelBindingId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceDeleteRequest): AccessReviewCommunicationServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string channel_binding_id */ 2:
                    message.channelBindingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string channel_binding_id = 2; */
        if (message.channelBindingId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelBindingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteRequest
 */
export const AccessReviewCommunicationServiceDeleteRequest = new AccessReviewCommunicationServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeleteResponse$Type extends MessageType<AccessReviewCommunicationServiceDeleteResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<AccessReviewCommunicationServiceDeleteResponse>): AccessReviewCommunicationServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewCommunicationServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewCommunicationServiceDeleteResponse): AccessReviewCommunicationServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewCommunicationServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteResponse
 */
export const AccessReviewCommunicationServiceDeleteResponse = new AccessReviewCommunicationServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewCommunicationService
 */
export const AccessReviewCommunicationService = new ServiceType("c1.api.accessreview.v1.AccessReviewCommunicationService", [
    { name: "GetChannel", localName: "getChannel$", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceGetChannelRequest, O: AccessReviewCommunicationServiceGetChannelResponse },
    { name: "ListChannels", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceListChannelsRequest, O: AccessReviewCommunicationServiceListChannelsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceCreateRequest, O: AccessReviewCommunicationServiceCreateResponse },
    { name: "Activate", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceActivateRequest, O: AccessReviewCommunicationServiceActivateResponse },
    { name: "Deactivate", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceDeactivateRequest, O: AccessReviewCommunicationServiceDeactivateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceDeleteRequest, O: AccessReviewCommunicationServiceDeleteResponse },
    { name: "ValidateChannelName", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceValidateChannelNameRequest, O: AccessReviewCommunicationServiceValidateChannelNameResponse }
]);
